import React from 'react';
import RouteKey from '../../../routes/key';
import MenuCollapseItem from '../../MenuCollapseItem';
import { useMenu } from '../DesktopMenu';
import { UseCollapseReturn } from '../MobileMenu';

const accessConfigurationLabel = 'Access Configuration';
const userGroupAccessConfigurationLabel = 'User Group and Access Configuration';
const accountManagementLabel = 'Account Management';

const { admin } = RouteKey.child;

const {
  userAccessConfiguration,
  accountManagement,
  accessRole,
  iExams2CandidateCreate,
  candidateBlacklist,
  userGroupAccessConfiguration,
  adminAccountManagement,
  userAccountManagement,
} = RouteKey.admin.child;

const adminAccountsPathDetails = [
  `/${admin}/${accessRole.route}`,
  `/${admin}/${userAccessConfiguration.route}`,
  `/${admin}/${userGroupAccessConfiguration.route}`,
  `/${admin}/${accountManagement.route}`,
  `/${admin}/${iExams2CandidateCreate.route}`,
];
const AccountsMenuItem = ({
  collapseMenuItem9,
  menu9Handle,
  setMobileMenuOpen,
}: {
  collapseMenuItem9: UseCollapseReturn;
  menu9Handle: (evt: any) => void;
  setMobileMenuOpen: (value: boolean) => void;
}) => {
  const { history, checkMenuPathsInLocation, checkSubMenuPathInLocation } = useMenu();

  return (
    <MenuCollapseItem
      {...collapseMenuItem9}
      handleClick={menu9Handle}
      label="Accounts"
      subMap={[
        'Admin',
        {
          id: 'menu-accounts-submenu-adminAccountManagement',
          label: accountManagementLabel,
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${adminAccountManagement.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${adminAccountManagement.route}`),
        },
        {
          id: 'menu-accounts-submenu-adminUserGroupAccessConfiguration',
          label: userGroupAccessConfigurationLabel,
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${userGroupAccessConfiguration.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(
            `/${admin}/${userGroupAccessConfiguration.route}`
          ),
        },
        'User',
        {
          id: 'menu-accounts-submenu-userAccessConfiguration',
          label: accessConfigurationLabel,
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${userAccessConfiguration.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${userAccessConfiguration.route}`),
        },
        {
          id: 'menu-accounts-submenu-userAccountManagement',
          label: accountManagementLabel,
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${userAccountManagement.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${userAccountManagement.route}`),
        },
        {
          id: 'menu-accounts-submenu-bulkCandidateCreation',
          label: 'Bulk Candidate Creation',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${iExams2CandidateCreate.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${iExams2CandidateCreate.route}`),
        },
        {
          id: 'menu-accounts-submenu-candidateBlacklist',
          label: 'Candidate Blacklist',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${candidateBlacklist.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${candidateBlacklist.route}`),
        },
      ]}
      isActiveMenu={checkMenuPathsInLocation(adminAccountsPathDetails)}
    />
  );
};

export default AccountsMenuItem;
